var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.938 12.25a.561.561 0 1 0 0-1.125H3.061a.56.56 0 0 0-.562.563c0 .312.25.562.563.562zM6.59 9.072a.56.56 0 0 0 .82 0l3-3.187a.563.563 0 0 0-.818-.771L7.562 7.27V2.313A.56.56 0 0 0 7 1.75a.56.56 0 0 0-.562.563V7.27L4.41 5.116a.563.563 0 0 0-.818.771l3 3.188z"
  })));
};
export default SvgDownload;